import theme_icons from '../../icons.js';

const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks; 
const { InnerBlocks, InspectorControls } = wp.blockEditor;
const { SelectControl, ColorPalette, PanelBody } = wp.components; 

 const greenheartcontainer = {
	title: 'Greenheart Container',
	icon: theme_icons.greenheart,
    category: 'greenheart',
    parent: ['rbt/greenheartframe'],
    supports: {
        align: ['wide', 'full']
    },
    attributes: {
        divider: {
            type: 'string',
            default: ''
        },
        dividerColor: {
            type: 'string',
            default: '',
        }
    },

	edit({attributes, setAttributes}){
		const { divider, dividerColor} = attributes;
        const returnStyleTags = () => {
            switch(divider){
                case "top":
                    return { borderTop: `1px solid ${dividerColor}` };
                case "bottom":
                    return { borderBottom: `1px solid ${dividerColor}` };
                case "both":
                    return { borderTop: `1px solid ${dividerColor}`, borderBottom: `1px solid ${dividerColor}` };
                default:
                    return {};
            }
        };
		return ([
        <InspectorControls>
            <PanelBody title="Section Settings">
                <p><strong>Include Dividers?</strong></p>
                <SelectControl
                    label={"Dividers"}
                    value={divider}
                    options={[
                        {label: "None", value:""},
                        {label: "Top Only", value: "top"},
                        {label: "Bottom Only", value: "bottom"},
                        {label: "Top and Bottom", value: "both"},
                    ]}
                    onChange={(val)=> setAttributes({divider:val})}
                />

                <p><strong>Divider Color</strong></p>
                <ColorPalette
                    value={dividerColor}
                    onChange={(color) => setAttributes({ dividerColor: color })}
                />
            </PanelBody>
        </InspectorControls>,
            <div className="theme-container" style={returnStyleTags()}>
                    <InnerBlocks /> 
            </div>
		]);
	},
	save({attributes}) {
		const { divider, dividerColor} = attributes;
        const returnStyleTags = () => {
            switch(divider){
                case "top":
                    return { borderTop: `1px solid ${dividerColor}` };
                case "bottom":
                    return { borderBottom: `1px solid ${dividerColor}` };
                case "both":
                    return { borderTop: `1px solid ${dividerColor}`, borderBottom: `1px solid ${dividerColor}` };
                default:
                    return {};
            }
        };

		return (
            <div className="theme-container" style={returnStyleTags()}>
                    <InnerBlocks.Content /> 
            </div>
		)
	}
};
registerBlockType('rbt/greenheartcontainer', greenheartcontainer);
export default greenheartcontainer;
